import { FC } from "react"
import Skeleton from "../base"

interface Props {
  cardCount?: number
}

const QuotesGroupSkeleton: FC<Props> = ({ cardCount = 4 }) => {
  return (
    <div className="py-3">
      {/* Date skeleton */}
      <div className="h-7 bg-neutral-200 rounded w-48 mb-4 animate-pulse" />

      {/* Cards grid skeleton */}
      <div className="grid grid-cols-1 lg:grid-cols-2 xl:grid-cols-3 2xl:grid-cols-4 gap-4">
        {Array.from({ length: cardCount }).map((_, index) => (
          <QuoteCardSkeleton key={index} />
        ))}
      </div>
    </div>
  )
}

const QuoteCardSkeleton: FC = () => {
  return (
    <Skeleton>
      <div className="border border-neutral-200 rounded-md flex flex-col">
        <div className="p-4 flex-1">
          {/* Rate percentage skeleton */}
          <div className="h-8 bg-neutral-200 rounded w-20 mb-2" />

          {/* Amortization term skeleton */}
          <div className="h-4 bg-neutral-200 rounded w-24 mb-4" />

          {/* Grid of details skeleton */}
          <div className="grid grid-cols-2 gap-2 mt-4">
            {/* Price row */}
            <div className="h-3 bg-neutral-200 rounded w-8 mb-3" />
            <div className="h-3 bg-neutral-200 rounded w-12 mb-3" />

            {/* Fee row */}
            <div className="h-3 bg-neutral-200 rounded w-16 mb-3" />
            <div className="h-3 bg-neutral-200 rounded w-10 mb-3" />

            {/* Loan amount row */}
            <div className="h-3 bg-neutral-200 rounded w-20 mb-3" />
            <div className="h-3 bg-neutral-200 rounded w-16 mb-3" />

            {/* P/I row */}
            <div className="h-3 bg-neutral-200 rounded w-6 mb-3" />
            <div className="h-3 bg-neutral-200 rounded w-14 mb-3" />

            {/* Type row */}
            <div className="h-3 bg-neutral-200 rounded w-8 mb-3" />
            <div className="h-3 bg-neutral-200 rounded w-20 mb-3" />

            {/* Investor row */}
            <div className="h-3 bg-neutral-200 rounded w-16 mb-3" />
            <div className="h-3 bg-neutral-200 rounded w-24" />
          </div>
        </div>

        {/* View details button skeleton */}
        <div className="h-12 bg-neutral-200 border-t border-neutral-200 rounded-b-md" />
      </div>
    </Skeleton>
  )
}

export default QuotesGroupSkeleton
